import { createSearchParams, useSearchParams } from 'react-router-dom';
export function useQueryParams(queryKey) {
    const [searchParams, setSearchParams] = useSearchParams();
    function hasQueryParam() {
        return searchParams.has(queryKey);
    }
    const getQueryParam = () => {
        return searchParams.get(queryKey);
    };
    const setQueryParam = (value) => {
        setSearchParams((searchParams) => {
            const newSearchParams = createSearchParams(searchParams);
            newSearchParams.set(queryKey, value);
            return newSearchParams;
        });
    };
    const removeQueryParam = () => {
        setSearchParams((searchParams) => {
            const newSearchParams = createSearchParams(searchParams);
            newSearchParams.delete(queryKey);
            return newSearchParams;
        });
    };
    return {
        hasQueryParam,
        getQueryParam,
        setQueryParam,
        removeQueryParam
    };
}
